import { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { t } from '../../utils/i18n'
import Popover from '../Popover'
import { optionSelected, bikeImageReload } from '../../actions'

const UncombinablePopover = () => {
  const dispatch = useDispatch()
  const { uncombinables, lang } = useSelector((state) => state)
  const [localUncombinables, setLocalUncombinables] = useState(uncombinables)

  const handleClick = useCallback(
    (e, component) => {
      if (optionSelected !== undefined) {
        setLocalUncombinables((prevUncombinables) =>
          prevUncombinables.filter(
            (uncombinable) => uncombinable.componentId !== component
          )
        )
        if (component !== undefined) {
          if (component === 'frame-size') {
            dispatch(optionSelected(component, '57'))
          } else if (component === 'electric-motor') {
            dispatch(optionSelected(component, 'pendix300'))
          } else {
            dispatch(optionSelected(component, 'off'))
          }
        }
        dispatch(bikeImageReload())
      }
    },
    [dispatch]
  )

  useEffect(() => {
    const handleDocumentClick = (e) => handleClick(e)
    document.addEventListener('click', handleDocumentClick, false)
    return () => {
      document.removeEventListener('click', handleDocumentClick, false)
    }
  }, [handleClick])

  if (localUncombinables.length > 2) {
    const links = {
      'axd-plate': 'https://i.ibb.co/4PtYV8k/axd-plate.png',
      'electric-motor': 'https://i.ibb.co/G3CZdmX/electric-motor.png',
      'frame-size': 'https://i.ibb.co/KwMyjhg/57cm.png'
    }
    return (
      <Popover
        className="velorbis-customizer-color-picker"
        width={'440px'}
        alignTo=".velorbis-customizer-header-share-desktop"
      >
        <div className="velorbis-customizer-popover-header">
          <span>{t('incompatible')}</span>
        </div>
        <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-scroll velorbis-customizer-space-dist-v velorbis-uncombinable-list">
          {localUncombinables.map((uncombinable) => (
            <div
              className="uncombinable"
              key={uncombinable.componentId}
              onClick={(e) => handleClick(e, uncombinable.componentId)}
            >
              <div className="uncombinable__component">
                {uncombinable.componentName[lang]}
              </div>
              {uncombinable.componentId === 'frame-size' &&
                uncombinable.componentId !== 'electric-motor' &&
                uncombinable.componentId !== 'axd-plate' && (
                  <div className="uncombinable__option">
                    {lang === 'da'
                      ? 'Skift stelstørrelse til'
                      : 'CHANGE FRAME SIZE TO'}
                  </div>
                )}
              {uncombinable.componentId !== 'frame-size' &&
                uncombinable.componentId === 'electric-motor' &&
                uncombinable.componentId !== 'axd-plate' && (
                  <div className="uncombinable__option">
                    {t('30WH_battery')}
                  </div>
                )}
              {uncombinable.componentId !== 'frame-size' &&
                uncombinable.componentId !== 'electric-motor' &&
                uncombinable.componentId === 'axd-plate' && (
                  <div className="uncombinable__option">
                    {lang === 'da'
                      ? 'Fjern logoplade center'
                      : 'REMOVE AD PLATE CENTER'}
                  </div>
                )}
              <img
                src={links[uncombinable.componentId]}
                className="uncombinable__image"
                alt="uncombinable_image"
              />
            </div>
          ))}
        </div>
      </Popover>
    )
  } else {
    return null
  }
}

export default UncombinablePopover
